if (!customElements.get("product-form")) {
  customElements.define(
    "product-form",
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector("form");
        this.form.addEventListener("submit", this.onSubmitHandler.bind(this));
        this.cartNotification = document.querySelector("cart-notification");
        this.cartItems = document.querySelector("cart-items");
        this.quickViewWarpper = document.getElementById("quickViewWrapper");
        //console.log(this.cartNotification);

        this.hideErrors = this.dataset.hideErrors === "true";
      }

      onSubmitHandler(evt) {
        evt.preventDefault();

        const submitButton = evt.submitter || this.querySelector('[type="submit"]');
        if (!submitButton || this.submitting) return;
        this.submitting = true;
        this.handleErrorMessage();
        let itemAdded = false;

        submitButton.setAttribute("disabled", true);
        submitButton.classList.add("loading");
        // Get Cart API
        let config = fetchConfig("javascript");
        config.headers["X-Requested-With"] = "XMLHttpRequest";
        delete config.headers["Content-Type"];

        let formData = new FormData(this.form);

        if (this.cartNotification) {
          formData.append(
            "sections",
            this.cartNotification
              .getSectionsToRender()
              .map((section) => section.id)
          );
          this.cartNotification.setActiveElement(document.activeElement);
        }

        formData.append("sections_url", window.location.pathname);
        config.body = formData;
        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((parsedState) => {

            if (parsedState.status) {
              this.handleErrorMessage(parsedState.description);
              return;
            }
            itemAdded = true;
            if (!this.cartNotification && !this.cartItems) {
              window.location.assign(routes.cart_url);
              return;
            }
            if (this.cartNotification) {
              this.cartNotification.renderContents(parsedState);
            }
            if (this.cartItems) {
              this.cartItems.renderContents(parsedState);
            }
            this
              .querySelector(".product-form__error-message-wrapper")
              ?.classList.add("no-js-inline");
          })
          .catch((e) => {
            console.error(e);
            const message = itemAdded
              ? (window.nsmCartMessages?.added || "Your item was added, but the bag could not open. View your bag before adding it again.")
              : (window.nsmCartMessages?.failed || "We could not confirm your bag update. Check your bag before trying again.");
            this.handleErrorMessage(message);
            const bagLink = document.createElement("a");
            bagLink.href = routes.cart_url;
            bagLink.textContent = window.nsmCartMessages?.view || "View bag";
            bagLink.style.cssText = "display:inline-block;margin-inline-start:8px;text-decoration:underline";
            this.errorMessage?.appendChild(bagLink);
          })
          .finally(() => {
            this.submitting = false;
            submitButton.classList.remove("loading");
            submitButton.removeAttribute("disabled");
            this.quickViewWarpper?.classList.remove("show__modal");
            document.body.classList.remove("overflow-hidden");
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper ||
          this.querySelector(".product-form__error-message-wrapper");
        if (!this.errorMessageWrapper) return;
        this.errorMessage =
          this.errorMessage ||
          this.errorMessageWrapper.querySelector(
            ".product-form__error-message"
          );
        if (!this.errorMessage) return;
        this.errorMessageWrapper.setAttribute("role", "alert");
        this.errorMessageWrapper.toggleAttribute("hidden", !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
          this.errorMessageWrapper.classList.remove("no-js-inline");
        }
      }
    }
  );
}

